var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.025,
    height: 66.154,
    viewBox: "0 0 60.025 66.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42116",
    "data-name": "Group 42116",
    transform: "translate(-23.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42803",
    "data-name": "Group 42803",
    transform: "translate(35.493 9.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189474",
    "data-name": "Path 189474",
    d: "M137.166,84.34H133.16V76.478a.821.821,0,0,0-.82-.82H119.666a.821.821,0,0,0-.82.82V84.34H114.84V76.478a4.831,4.831,0,0,1,4.826-4.826H132.34a4.831,4.831,0,0,1,4.826,4.826l.953,3.868Z",
    transform: "translate(-114.84 -71.652)",
    fill: "#6c7fd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42804",
    "data-name": "Group 42804",
    transform: "translate(50.773 9.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189475",
    "data-name": "Path 189475",
    d: "M235.325,71.652h-2.219a4.831,4.831,0,0,1,4.826,4.826V84.34h2.219l.953-3.994-.953-3.868a4.831,4.831,0,0,0-4.826-4.826Z",
    transform: "translate(-233.106 -71.652)",
    fill: "#4f66d0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_189476",
    "data-name": "Path 189476",
    d: "M69.592,198.036v-.047a26.155,26.155,0,0,0-.289-3.877l-4.819-32.16a2.8,2.8,0,0,0-2.77-2.405H31.722a2.8,2.8,0,0,0-2.769,2.4l-4.931,32.123a26.163,26.163,0,0,0-.3,3.97l22.936,2.8Z",
    transform: "translate(0 -138.932)",
    fill: "#f6a96c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189477",
    "data-name": "Path 189477",
    d: "M294.25,197.988v.047l-3.73.456-.932-.456v-.047a26.065,26.065,0,0,0-.289-3.877l-4.818-32.16a2.8,2.8,0,0,0-2.77-2.405h4.66a2.8,2.8,0,0,1,2.77,2.405l4.82,32.16A26.253,26.253,0,0,1,294.25,197.988Z",
    transform: "translate(-224.657 -138.931)",
    fill: "#ea9b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189481",
    "data-name": "Path 189481",
    d: "M23.719,457.436H69.592v4.252a2.8,2.8,0,0,1-2.8,2.8H26.517a2.8,2.8,0,0,1-2.8-2.8Z",
    transform: "translate(0 -398.332)",
    fill: "#ea9b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189482",
    "data-name": "Path 189482",
    d: "M323.825,457.436v4.252a2.8,2.8,0,0,1-2.8,2.8h4.661a2.8,2.8,0,0,0,2.8-2.8v-4.252Z",
    transform: "translate(-258.893 -398.332)",
    fill: "#d88a55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189483",
    "data-name": "Path 189483",
    d: "M311.048,23.886H290.136a2.507,2.507,0,0,1-2.507-2.507V2.507A2.507,2.507,0,0,1,290.136,0h20.912a2.507,2.507,0,0,1,2.507,2.507V21.379A2.507,2.507,0,0,1,311.048,23.886Z",
    transform: "translate(-229.811 0)",
    fill: "#fe646f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189484",
    "data-name": "Path 189484",
    d: "M446.436,0h-3.33a2.507,2.507,0,0,1,2.507,2.507V21.379a2.507,2.507,0,0,1-2.507,2.507h3.33a2.507,2.507,0,0,0,2.507-2.507V2.507A2.507,2.507,0,0,0,446.436,0Z",
    transform: "translate(-365.199)",
    fill: "#fd4755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189485",
    "data-name": "Path 189485",
    d: "M344.958,45.677a.43.43,0,0,1,0-.61l2.514-2.514a1.388,1.388,0,0,0,0-1.965L345.681,38.8a1.389,1.389,0,0,0-1.963,0l-.767.767L341.2,41.313a.431.431,0,0,1-.61,0L338.077,38.8a1.389,1.389,0,0,0-1.964,0l-1.792,1.791a1.389,1.389,0,0,0,0,1.964l2.515,2.515a.431.431,0,0,1,0,.609l-2.515,2.515a1.389,1.389,0,0,0,0,1.964l1.792,1.791a1.389,1.389,0,0,0,1.964,0l2.515-2.515a.431.431,0,0,1,.61,0l1.749,1.748.767.767a1.387,1.387,0,0,0,1.963,0l1.792-1.79a1.388,1.388,0,0,0,0-1.965Z",
    transform: "translate(-270.116 -33.43)",
    fill: "#f3f0f3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundSvg);
export default __webpack_public_path__ + "static/media/refundSVG.ec6290feb03973d37589077a0e5510d4.svg";
export { ForwardRef as ReactComponent };